import { signalRService } from '../signalr/SignalRService';
import { HubMethods } from '../signalr/types';

/**
 * P5 — client wire for the server-authoritative co-op GameSession framework. A game action is a
 * `game_delta` SocialEvent (the stringified-outer-envelope law); the server validates it per the
 * GameKind rule module, merges state under an advisory lock, and broadcasts the authoritative
 * `game_state` back to the room (rendered by GamePanel). Nothing here decides outcomes or Sparks —
 * those are server-only.
 */
class GameSessionService {
  /** Send a game action (e.g. "start", "smash", "sync"). Fire-and-forget-ish; returns {ok}. */
  async sendDelta(
    currentRoomId: string,
    gameId: string,
    action: string,
    payload?: Record<string, unknown>,
  ): Promise<{ ok: boolean; status?: string }> {
    try {
      const inner = JSON.stringify({
        gameId,
        action,
        payloadJson: payload ? JSON.stringify(payload) : null,
      });
      const envelopeJson = JSON.stringify({ type: 'game_delta', payloadJson: inner });
      const json = await signalRService.invoke<string>(HubMethods.SocialEvent, currentRoomId, envelopeJson);
      return typeof json === 'string' ? JSON.parse(json) : (json as { ok: boolean });
    } catch (e) {
      console.error(`[GameSession] ${action} failed:`, e);
      return { ok: false };
    }
  }
}

export const gameSessionService = new GameSessionService();
